import React, { useEffect, useState } from 'react'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import AdProductCard from '../../../components/AdProductCard'
import AdStoreCard from '../../../components/AdStoreCard'
import AdShelfCard from '../../../components/AdShelfCard'
import StorePreviousAdCard from '../../../components/StorePreviousAdCard'


const AdSelector = () => {
    const [biz, setBiz] = useState(null)
    const [products, setProducts] = useState([])
    const [shelves, setShelves] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    const { name } = useParams()
    // console.log(name)
    const navigate = useNavigate()

    useEffect(() => {
        getContent()
    }, [])

    const getContent = async () => {
        try {
            setIsLoading(true)
            const response = await api.get(`/stores/${name}/manage/promotions`)
            // console.log(response)
            setIsLoading(false)
            if (response) {
                setBiz(response.data.store)
                setProducts(response.data.products)
                setShelves(response.data.shelves)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
    }
    return (
        <div>
            <h2 className="header-title">Posts You can Promote</h2>
            <div className="ads-selector">
                <div className="ads-select">
                    <h3>{name}</h3>
                    {biz &&
                        <AdStoreCard ad={biz} />
                    }
                </div>
                <div className="ads-select">
                    <h2>Promote Products</h2>
                    {!isLoading && !products?.length && <p>No products found</p>}

                    {
                        products?.map((product) => (
                            <AdProductCard product={product} />
                        ))
                    }
                    <button onClick={() => navigate(`/b/manage/${name}/promotions/products`)}>See more</button>
                </div>
                <div className="ads-select">
                    <h2>Promote Shelves</h2>
                    {!isLoading && !shelves?.length && <p>No shelves found</p>}

                    {
                        shelves?.map((shelf) => (
                            <AdShelfCard shelf={shelf} store={biz} />
                        ))
                    }
                    <button onClick={() => navigate(`/b/manage/${name}/promotions/shelves`)}>See more</button>
                </div>
                <div className="ads-select">
                    <button onClick={() => navigate(`/b/manage/${name}/promotions/previous`)}>Previous Ads</button>
                </div>
            </div>
        </div>
    )
}

export default AdSelector